import { Component, OnInit } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import { moduli } from '../../config';
import { SkladisteHladService } from './skladiste-hlad.service';

@Component({
  selector: 'app-skladiste-hlad',
  templateUrl: './skladiste-hlad.component.html',
  styleUrls: ['./skladiste-hlad.component.scss'],
  providers: [SkladisteHladService],
})
export class SkladisteHladComponent implements OnInit {
  constructor(private service: SkladisteHladService) {
    // PRAVA KORISNIKA
    this.trenutniPogled = moduli().skladisteHlad;
    for (var i = 0; i < this.pravaKorisnika.length; i++) {
      //console.log(i);
      if (this.pravaKorisnika[i].smo_ime == this.trenutniPogled) {
        this.pravaZaTrenutniPogled = this.pravaKorisnika[i].sgm_prava;
        //console.log(this.pravaZaTrenutniPogled);
        if (this.pravaKorisnika[i].sgm_prava != 0) {
          this.prikaziStranicu = 1;
        } else {
          notify('Nemate prava.', 'error', 3000);
        }
        return;
      } else {
      }
    }
    // KRAJ PRAVA KORISNIKA
  }

  tablica: any;
  promet: any;
  poruka: string;
  disableGumb: boolean = false;
  sifra: any;
  datumOd = moment();
  datumDo = moment();
  o = moment().format('YYYY-MM-DD');
  d = moment().format('YYYY-MM-DD');

  // PRAVA KORISNIKA
  pravaKorisnika = JSON.parse(sessionStorage.getItem('pravakorisnika'));
  trenutniPogled: any;
  pravaZaTrenutniPogled: any;
  prikaziStranicu = 0;
  // KRAJ PRAVA KORISNIKA

  ngOnInit() {
    
  }

  pretrazi(){
    this.prometRobe();
  }

  prometRobe() {
    this.disableGumb = true;
    this.tablica = [];
    this.service.ukupanPromet({}).subscribe((res) => {
      console.log(res);
      this.disableGumb = false;
      if (res.success == true) {
        if (res.data.length == 0) {
          this.poruka = 'Nema podataka!';
        } else {
          this.poruka = 'Učitavanje...';
        }
        for (let data of res.data) {
          this.tablica.push({
            sifra: data.ar_sifra,
            lot: data.ar_lot,
            datum: moment(data.do_datum).format('DD.MM.YYYY.'),
            idlot: data.idlotpromet,
            naziv: data.ar_naziv,
            ulaz: data.ukupnoulaz,
            izlaz: data.ukupnoizlaz,
            razlika: data.razlika,
          });
        }
      } else {
        this.poruka = 'Greška konekcije ili baze!';
      }
    });
  }

  onCellClick(e) {
    // console.log(e);
    if (e.columnIndex != 0) {
      e.event.stopImmediatePropagation();
    }
  }

  trenutnaRoba(data) {
    console.log(data);
    if (data.rowType != 'detail') {
      this.sifra = data.data.sifra;
      this.promet = [];
      let object = {
        artiklsifra: this.sifra,
        datumod: '2021-01-01',
        datumdo: '2022-01-01',
      };
      this.service.trenutanPromet(object).subscribe((res) => {
        console.log(res);
        if (res.success == true) {
          if (res.data.length == 0) {
            this.poruka = 'Nema podataka!';
          } else {
            this.poruka = 'Učitavanje...';
          }
          for (let data of res.data) {
            this.promet.push({
              sifra: data.ar_sifra,
              dokBroj: data.do_broj,
              dokVrsta: data.dv_sifra,
              lot: data.ar_lot,
              idlot: data.idlotpromet,
              naziv: data.ar_naziv,
              datum: moment(data.do_datum).format('DD.MM.YYYY.'),
              ulaz: data.pr_ulaz,
              izlaz: data.pr_izlaz,
              stanje: data.stanjerobe,
              komora: data.komora_idkomora,
              red: data.red_idred,
              strana: data.strana,
            });
          }
          this.prometRobe();
        } else {
          this.poruka = 'Greška konekcije ili baze!';
        }
      });

      var key = data.component.getKeyByRowIndex(data.rowIndex);
      var expanded = data.component.isRowExpanded(key);
      if (expanded) {
        data.component.collapseAll(-1);
        setTimeout(function () {
          data.component.expandRow(key);
        }, 100);
      }
    }
  }

  // Promjena datuma
  onValueChangedDatumOd(e) {
    // console.log(e);
    this.datumOd = e.value;
    this.o = moment(e.value).format('YYYY-MM-DD');
  }
  onValueChangedDatumDo(e) {
    // console.log(e);
    this.datumDo = e.value;
    this.d = moment(e.value).format('YYYY-MM-DD');
  }

  onToolbarPreparing(e) {
    var toolbarItems = e.toolbarOptions.items;
    toolbarItems.unshift({
      location: 'before',
      template: 'naslovTablice',
    });
  }
}
